// Tailwind defaults -- https://github.com/tailwindlabs/tailwindcss/blob/master/stubs/config.full.js#L780
// screens: {
//     sm: '640px', // 40em
//     md: '768px', // 48em
//     lg: '1024px', // 64em
//     xl: '1280px', // 80em
//     '2xl': '1536px', // 90em
//   },
// Chakra defaults (v2) -- https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/foundations/breakpoints.ts
export const BREAKPOINTS_PX = {
    base: 0,
    xs: 1,
    sm: 768,
    md: 1024,
    'lg-sm': 1250,
    lg: 1358,
    xl: 1800,
    '2xl': 3840,
};

export const breakpoints = {
    base: `${BREAKPOINTS_PX.base}px`,
    xs: `${BREAKPOINTS_PX.xs}px`,
    sm: `${BREAKPOINTS_PX.sm}px`,
    md: `${BREAKPOINTS_PX.md}px`,
    'lg-sm': '1250px',
    lg: `${BREAKPOINTS_PX.lg}px`,
    xl: `${BREAKPOINTS_PX.xl}px`,
    '2xl': `${BREAKPOINTS_PX['2xl']}px`,
};
